// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"351":"f165e226","646":"df32868a"}[chunkId] + ".chunk.css";
};